import { selectUser } from '../reducers/login'
import { SagaContext, waitForState } from './types'


export default async function onInit(ctx: SagaContext) {
    await waitForState(ctx, selectUser)

    // runs when have a user
}